import { addDays, addWeeks, startOfYear } from "date-fns";

export interface ItemSummary {
  name: string;
  listItems: string[];
}

export const summaryItems: ItemSummary[] = [
  {
    name: "Account Summary",
    listItems: [
      "Holdings",
      "Orders",
      "Fiat Transactions",
      "Crypto Deposits",
      "Crypto Withdrawals",
      "Other Transactions (Air Drops, C&B Promo, etc)",
    ],
  },
  {
    name: "Transaction Summary",
    listItems: ["Fiat Transactions", "Crypto Deposits", "Crypto Withdrawals", "Other Transactions"],
  },
];

export const timeRangeOptions = [
  "All time",
  "Last 24 Hours",
  "Last 2 Weeks",
  "Last 30 Days",
  "Last 90 Days",
  "Year to Date",
  "Custom",
];

export const mobileCategories = ["Account", "Transactions"];

export const modalDisclaimer =
  "* Please contact us at support@calebandbrown.com if you require a summary older than Aug 2020.";

export function getAustralianEOFYDatesInMilliseconds(): number[] {
  // Get the starting date of the last financial year (July 1st of last year)
  const julyFirst2022 = new Date(2022, 6, 1);

  // Get the ending date of the current financial year (June 30th of this year)
  const juneThirtieth2023 = new Date(2023, 5, 30);

  // Return an array with the start and end dates in milliseconds
  return [julyFirst2022.getTime(), juneThirtieth2023.getTime()];
}

export function getUSEOFYDatesInMilliseconds(): number[] {
  // Get the starting date of the U.S. individual fiscal year (January 1st of this year)
  const usEOFYIndividualStart = new Date(2023, 0, 1);

  // Get the ending date of the U.S. individual fiscal year (December 31st of this year)
  const usEOFYIndividualEnd = new Date(2023, 11, 31);

  // Return an array with the start and end dates in milliseconds
  return [usEOFYIndividualStart.getTime(), usEOFYIndividualEnd.getTime()];
}

export const handleChangeStartDate = (timeRange: string): number | undefined => {
  const currentDate = new Date();

  switch (timeRange) {
    case "Last 24 Hours":
      return addDays(currentDate, -1).getTime();
    case "Last 2 Weeks":
      return addWeeks(currentDate, -2).getTime();
    case "All time":
      return undefined;
    case "Last 30 Days":
      return addDays(currentDate, -30).getTime();
    case "Last 90 Days":
      return addDays(currentDate, -90).getTime();
    case "Year to Date":
      return startOfYear(currentDate).getTime();
    default:
      return 0;
  }
};
